// extracted by mini-css-extract-plugin
export default {"requiredTitle":"PermitAttachmentBar_requiredTitle__oMSN4"};